// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search .k-label {
  font-weight: normal;
}
.search .more-filters {
  padding-top: 25px;
  padding-bottom: 35px;
}
.search .more-filter-controls .k-form-field {
  display: flex;
  font-size: 16px;
  align-items: center;
  margin-bottom: 20px;
}
.search .more-filter-controls .k-form-field .k-label {
  text-align: right;
  padding-right: 12px;
  font-weight: normal;
}
.search .more-filter-controls kendo-daterange {
  display: flex;
}
.search .more-filter-controls .k-dateinput {
  margin-right: 10px;
}
.search .search-box {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1882352941);
  display: flex;
}
.search .search-box .k-autocomplete {
  border: none;
}
.search .search-box .search-btn.k-button {
  font-size: 18px;
  font-weight: normal;
  background: #0F5597;
  color: #ffffff;
  text-transform: uppercase;
}
.search .search-box .k-button.k-button-clear {
  height: 50px;
  min-width: 0;
  color: #000000;
}
.search .k-autocomplete {
  width: 100%;
  height: 50px;
}
.search .k-autocomplete .k-input {
  height: 50px;
}
.search .k-form-field > div {
  flex-grow: 1;
}
.search .k-input {
  padding-left: 22px;
  height: 50px;
}
.search .k-upload {
  width: 70%;
  margin-left: auto;
}
.search .k-textarea {
  width: 100%;
}
.search .k-textbox, .search .k-numerictextbox, .search .k-dateinput {
  width: 100%;
  height: 50px;
}
.search .more-filter-btn.k-button {
  color: #005596;
  font-size: 20px;
}
.search th {
  background-color: #f3f3f3;
  color: black;
}
.search .k-button {
  height: 50px;
  max-width: 300px;
  text-transform: unset;
}
.search .download-csv-btn.k-button.k-outline {
  color: #005596;
  font-size: 18px;
}
.search h4.manage-users-heading {
  cursor: pointer;
  color: #0f5597;
}

.display-flex {
  display: flex;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/search-contact/search-contact-box.component.scss"],"names":[],"mappings":"AACI;EACI,mBAAA;AAAR;AAGI;EACI,iBAAA;EACA,oBAAA;AADR;AAMQ;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,mBAAA;AAJZ;AAMY;EACI,iBAAA;EACA,mBAAA;EACA,mBAAA;AAJhB;AAQQ;EACI,aAAA;AANZ;AASQ;EACI,kBAAA;AAPZ;AAWI;EACI,iDAAA;EACA,aAAA;AATR;AAWQ;EACI,YAAA;AATZ;AAYQ;EACI,eAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,yBAAA;AAVZ;AAaQ;EACI,YAAA;EACA,YAAA;EACA,cAAA;AAXZ;AAeI;EACI,WAAA;EACA,YAAA;AAbR;AAeQ;EACI,YAAA;AAbZ;AAiBI;EACI,YAAA;AAfR;AAkBI;EACI,kBAAA;EACA,YAAA;AAhBR;AAmBI;EACI,UAAA;EACA,iBAAA;AAjBR;AAoBI;EACI,WAAA;AAlBR;AAqBI;EACI,WAAA;EACA,YAAA;AAnBR;AAuBI;EACI,cAAA;EACA,eAAA;AArBR;AAwBI;EACI,yBAAA;EACA,YAAA;AAtBR;AAyBI;EACI,YAAA;EACA,gBAAA;EACA,qBAAA;AAvBR;AA0BI;EACI,cAAA;EACA,eAAA;AAxBR;AA2BI;EACI,eAAA;EACA,cAAA;AAzBR;;AA6BA;EACI,aAAA;AA1BJ","sourcesContent":[".search {\n    .k-label {\n        font-weight: normal;\n    }\n\n    .more-filters {\n        padding-top: 25px;\n        padding-bottom: 35px;\n    }\n\n    .more-filter-controls {\n\n        .k-form-field {\n            display: flex;\n            font-size: 16px;\n            align-items: center;\n            margin-bottom: 20px;\n\n            .k-label {\n                text-align: right;\n                padding-right: 12px;\n                font-weight: normal;\n            }\n        }\n\n        kendo-daterange {\n            display: flex;\n        }\n\n        .k-dateinput {\n            margin-right: 10px;\n        }\n    }\n\n    .search-box {\n        box-shadow: 0 2px 4px #00000030;\n        display: flex;\n\n        .k-autocomplete {\n            border: none;\n        }\n\n        .search-btn.k-button {\n            font-size: 18px;\n            font-weight: normal;\n            background: #0F5597;\n            color: #ffffff;\n            text-transform: uppercase;\n        }\n\n        .k-button.k-button-clear {\n            height: 50px;\n            min-width: 0;\n            color: #000000;\n        }\n    }\n\n    .k-autocomplete {\n        width: 100%;\n        height: 50px;\n\n        .k-input {\n            height: 50px;\n        }\n    }\n\n    .k-form-field > div {\n        flex-grow: 1;\n    }\n\n    .k-input {\n        padding-left: 22px;\n        height: 50px;\n    }\n\n    .k-upload {\n        width: 70%;\n        margin-left: auto;\n    }\n\n    .k-textarea {\n        width: 100%;\n    }\n\n    .k-textbox, .k-numerictextbox, .k-dateinput {\n        width: 100%;\n        height: 50px;\n      \n    }\n\n    .more-filter-btn.k-button {\n        color: #005596;\n        font-size: 20px;\n    }\n\n    th {\n        background-color: #f3f3f3;\n        color: black;\n    }\n\n    .k-button {\n        height: 50px;\n        max-width: 300px;\n        text-transform: unset;\n    }\n\n    .download-csv-btn.k-button.k-outline {\n        color: #005596;\n        font-size: 18px;\n    }\n\n    h4.manage-users-heading {\n        cursor: pointer;\n        color: #0f5597;\n    }\n}\n\n.display-flex{\n    display: flex;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
